var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarPairingSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0v2c7.7197266,0,14,6.2802734,14,14h2C32,7.1777344,24.8222656,0,16,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,5v2c4.9628906,0,9,4.0371094,9,9h2C27,9.9345703,22.0654297,5,16,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,10v2c2.2060547,0,4,1.7939453,4,4h2C22,12.6914062,19.3085938,10,16,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7645874,18.2927246l-1.3173218-2.6345215C15.9355469,14.6357422,14.9072266,14,13.7636719,14H6.2363281 c-1.1435547,0-2.171875,0.6357422-2.6835938,1.6582031l-1.3173218,2.6345215C0.852356,19.126709,0,20.6008301,0,22.2363281 L0.0048828,28v2.2832031C0.0048828,31.2460938,0.8828125,32,2.0029297,32h1.9980469C5.1220703,32,6,31.2460938,6,30.2832031V28h8 v2.2832031C14,31.2460938,14.8789062,32,16,32h2c1.1210938,0,2-0.7539062,2-1.7167969v-8.046875 C20,20.6008301,19.147644,19.126709,17.7645874,18.2927246z M6.2363281,16h7.5273438 c0.3818359,0,0.7246094,0.2119141,0.8945312,0.5527344L15.3818359,18H4.6181641l0.7236328-1.4472656 C5.5117188,16.2119141,5.8544922,16,6.2363281,16z M4,30H2.0048828v-2H4V30z M18,30h-2v-2h2V30z M18,26H2.0048828L2,24.0146484h4 v-2H2.0285645C2.0995483,21.1809082,2.5407104,20.4345703,3.2558594,20h13.4882812 c0.7151489,0.4345703,1.1563721,1.1809082,1.227356,2.0146484H14v2h4V26z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarPairingSmall);
export default __webpack_public_path__ + "static/media/car-pairing--small.920672a4adfdf1651f95f4d4f65d16a0.svg";
export { ForwardRef as ReactComponent };